export default __webpack_public_path__ + "static/media/image_pregunta.daa3b398.png";